import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';
import { sendEmail, sendEmailVariables } from './types/sendEmail';

@Injectable({ providedIn: 'root' })
export class ContactFormGQL extends Mutation<sendEmail, sendEmailVariables> {
  document = gql`
    mutation sendEmail(
      $ContactFormSubscriberDtoInput: ContactFormSubscriberDtoInput!
    ) {
      sendEmail(subscriber: $ContactFormSubscriberDtoInput) {
        success
        errorCause
      }
    }
  `;
}
